module.exports = __webpack_public_path__ + "static/img/car.b115493.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/image/car.png
// module id = 8jTK
// module chunks = 1